<template>
  <div class="modal-content">
    <!-- TODO add this -->
    <!-- <v-overlay :value="!!tradeId" opacity=".9" class="text-center">
      <h3>Your trade offer is ready</h3>
      <p>Click the button below to open Steam and accept the offer.</p>
      <v-btn
        tile x-large depressed
        color="blue700 blue200--text"
        class="font-weight-semibold"
        :ripple="false"
        rel="noopener noreferrer"
        target="_blank"
        :href="`https://steamcommunity.com/tradeoffer/${tradeId}`"
        @click="close()"
      >
        <fai :icon="['fab', 'steam']" class="mr-2" />
        <span v-t="'page.account.trades.cta.open'" />
      </v-btn>
    </v-overlay> -->

    <!-- Header -->
    <div class="py-0 px-0 d-flex align-center justify-space-between mb-3">
      <span>
        <span v-t="'page.deposit.method.rust.title'" class="text-uppercase font-weight-bold" />
        <span class="ml-2 font-weight-bold">
          <span>(</span>
          <scrap :amount="invValue" />
          <span>)</span>
        </span>
      </span>
      <div class="d-flex fw-regular flex-center">
        <v-text-field
          v-model="search"
          class="mr-2 rounded-0"
          background-color="grey800"
          hide-details solo dense flat
          :placeholder="$t('common.search')"
        />
        <v-tooltip top color="primary500">
          <template #activator="{on}">
            <v-btn
              :color="hideBlacklisted ? 'primary600 primary100--text' : 'primary800 primary400--text'"
              class="rounded-0 unwidth mr-2"
              :ripple="false"
              v-on="on" @click="hideBlacklisted = !hideBlacklisted"
            >
              <fai class="text-body-1" :icon="['fad','ban']" />
            </v-btn>
          </template>
          <span v-t="'page.deposit.method.rust.hide_blacklisted'" />
        </v-tooltip>
        <v-btn
          color="blue700" class="rounded-0 unwidth"
          :ripple="false" :disabled="loading.inventory" @click="getInventory"
        >
          <fai class="blue500--text" :spin="loading.inventory" :icon="['fas','sync']" />
        </v-btn>
      </div>
    </div>

    <!-- Items -->
    <div class="mb-3">
      <Inventory
        v-if="filteredItems.length || loading.inventory"
        :items="filteredItems" :loading="loading.inventory"
        @onItemClick="selectItem" @onItemAmountChange="changeItemAmount"
      />
      <div v-else class="faded-5 d-flex align-center justify-center grey300 py-16 mb-3">
        <span v-if="search" v-t="'inventory.no_items_filtered'" />
        <span v-else v-t="'inventory.no_items'" />
      </div>
    </div>

    <!-- Footer -->
    <div class="d-flex pa-4 grey800 align-center justify-space-between">
      <div class="grey100--text">
        <div class="mb-2 d-flex align-center">
          <span v-t="'page.deposit.method.rust.receive'" class="font-weight-bold mr-1" />
          <scrap :amount="selectedValue" />

          <span v-if="bonus && selectedValueBonus - selectedValue > 0" class="ml-2 text-body-2 font-weight-bold green500--text">
            (+{{ selectedValueBonus - selectedValue | toScrap }} {{ $t('common.bonus').toLowerCase() }})
          </span>
        </div>
        <div class="caption faded-8 lh-1">
          {{ selectedCount }}<small class="faded-5">/{{ maxItemSelect }}</small>
          <span v-t="'page.deposit.method.rust.items_selected'" />
        </div>
      </div>
      <div class="btns">
        <v-btn
          v-t="'cta.cancel'"
          color="primary700" small depressed
          :ripple="false"
          :disabled="loading.deposit"
          class="rounded-0 px-5 primary300--text font-weight-bold mr-3"
          @click="close"
        />

        <v-btn
          color="green800 green500--text"
          large depressed :ripple="false"
          class="rounded-0 px-8 font-weight-bold"
          :loading="loading.deposit"
          :disabled="!canDeposit"
          @click="deposit"
        >
          <span v-t="'cta.deposit'" />
          <scrap v-show="selectedValue" class="ml-1 text-lowercase green500--text" :amount="selectedValueBonus" />
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
// reference https://gyazo.com/b13a9932fab2b0742e7adff3f482a36d

// TODO show tradeurl box if not set

import sortBy from 'lodash.sortby'

import Inventory from '@/components/Inventory'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    Inventory,
  },
  props: ['close'],
  data() {
    return {
      loading: {
        inventory: false,
        deposit: false,
      },
      items: [],
      hideBlacklisted: false,
      search: '',
    }
  },
  computed: {
    ...mapGetters({
      conga: 'conga/conga',
      user: 'user/session',
    }),
    maxItemSelect() {
      return 30
    },
    affBonus() {
      const bonus = this.conga.affiliates?.bonus?.market ?? 0
      return this.user.hasRefCode ? bonus : 0
    },
    bonus() {
      return this.affBonus + this.conga.deposits?.market?.bonus ?? 0
    },
    //
    invValue() {
      return this.items.reduce((acc, i) => acc + i.price * i.amount, 0)
    },
    selected() {
      return this.items.filter(i => i.selected)
    },
    selectedCount() {
      return this.selected.reduce((acc, i) => acc + (i.amountSelected || 1), 0)
    },
    selectedValue() {
      return this.selected.reduce((acc, i) => acc + (i.price * (i.amountSelected || 1)), 0)
    },
    selectedValueBonus() {
      if (!this.bonus) return this.selectedValue

      return Math.floor(this.selectedValue * (1 + this.bonus))
    },
    canDeposit() {
      return this.selectedCount <= this.maxItemSelect
    },
    filteredItems() {
      let items = [...this.items]

      const { search, hideBlacklisted } = this


      if (search !== '') {
        items = items.filter(i => i.name.toLowerCase().includes(search.toLowerCase()))
      }

      if (hideBlacklisted) {
        items = items.filter(i => !i.blacklisted)
      }

      return sortBy(items, 'price').reverse()
    },
  },
  mounted() {
    //
    this.getInventory()
  },
  methods: {
    ...mapActions({
      getSteamInventory: 'user/getSteamInventory',
      _deposit: 'user/deposit',
    }),
    async getInventory() {
      if (this.loading.inventory) return
      this.loading.inventory = true

      try {
        const items = await this.getSteamInventory('deposit')
        this.items = items.map(i => ({
          ...i,
          price: i.price ?? 0,
          selected: false,
          amountSelected: 1,
        }))
      } catch (err) {
        this.$toast.error(err.message)
      } finally {
        this.loading.inventory = false
      }
    },
    async deposit() {
      if (this.loading.deposit) return

      const selected = this.selected.map(i => ({
        assetid: i.assetid,
        amount: i.amountSelected ?? 1,
      }))

      if (!selected.length) return

      this.loading.deposit = true

      try {
        await this._deposit(selected)
        this.close()
      } catch (err) {
        this.$toast.error(err.message)
      } finally {
        this.loading.deposit = false
      }
    },
    selectItem(item) {
      if (item.blacklisted) return
      if (!item.selected && this.selectedCount >= this.maxItemSelect) return

      // eslint-disable-next-line no-param-reassign
      item.selected = !item.selected
    },
    changeItemAmount(item, val) {
      if (item.amount < 2) return
      // eslint-disable-next-line no-param-reassign
      item.amountSelected = val

      // eslint-disable-next-line no-param-reassign
      item.selected = true
    },
  },
}
</script>

<style lang="scss" scoped>
.inventory {
  max-height: 500px;
}
</style>
